import {
  DialogActions,
  DialogActionsProps,
  DialogTitle,
  useTheme,
} from "@mui/material";
import RSButton, { RSButtonProps } from "ds_legacy/components/RSButton";
import { HorizontalLayout } from "ds_legacy/materials/layouts";
import { margin, padding, sizing } from "ds_legacy/materials/metrics";
import { FONT_SIZE_20, FONT_WEIGHT_BOLD } from "ds_legacy/materials/typography";
import { Halo } from "dsl/atoms/Halo";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { UserIcon } from "lucide-react";

export const ASSESSMENT_MODAL_STEP_AUCTION = 1;
export const ASSESSMENT_MODAL_STEP_PATIENT_SELECTOR = 2;
export const ASSESSMENT_MODAL_STEP_ASSESSMENT = 3;
export const ASSESSMENT_MODAL_STEP_REQUEST = 4;

export type AssessmentModalStep =
  | typeof ASSESSMENT_MODAL_STEP_AUCTION
  | typeof ASSESSMENT_MODAL_STEP_PATIENT_SELECTOR
  | typeof ASSESSMENT_MODAL_STEP_ASSESSMENT
  | typeof ASSESSMENT_MODAL_STEP_REQUEST
  | null;

export const ModalHeader = ({ title }: { title: string }) => {
  const theme = useTheme();
  return (
    <>
      <HorizontalLayout justify="center" width="100%">
        <Halo
          backgroundColor={theme.palette.neutrals.base_light}
          padding={sizing(1.5)}
        >
          <UserIcon size={sizing(7.5)} style={{ fontSize: sizing(7.5) }} />
        </Halo>
      </HorizontalLayout>
      <DialogTitle
        fontSize={FONT_SIZE_20}
        fontWeight={FONT_WEIGHT_BOLD}
        margin={margin(0)}
        sx={{ padding: padding(2, 0) }}
        textAlign="center"
      >
        {title}
      </DialogTitle>
    </>
  );
};

export function ProviderSearchModalActions({
  cancelProps,
  cancelText,
  dialogActionsSx,
  onCancel,
  onSubmit,
  submitProps,
  submitText,
}: {
  cancelProps: Partial<RSButtonProps>;
  cancelText: string;
  dialogActionsSx?: DialogActionsProps["sx"];
  onCancel: () => void;
  onSubmit: () => void;
  submitProps: Partial<RSButtonProps>;
  submitText: string;
}) {
  const { isMobile } = useMedia();

  return (
    <DialogActions
      sx={{
        boxSizing: "border-box",
        justifyContent: "center",
        margin: margin(0),
        padding: padding(2, 3),
        width: "100%",
        ...dialogActionsSx,
      }}
    >
      <RSButton
        {...(cancelProps as RSButtonProps)}
        buttonWrapperStyle={{ margin: margin(0, 1.5, 0) }}
        color="primary"
        loading={cancelProps.loading ?? "na"}
        style={{ margin: 0, width: isMobile ? "auto" : sizing(20) }}
        variant="outlined"
        onClick={onCancel}
      >
        {cancelText}
      </RSButton>
      <RSButton
        {...(submitProps as RSButtonProps)}
        buttonWrapperStyle={{ margin: 0 }}
        color="primary"
        inverted
        loading={submitProps.loading ?? "na"}
        style={{ margin: 0, width: sizing(20) }}
        type="submit"
        variant="outlined"
        onClick={onSubmit}
      >
        {submitText}
      </RSButton>
    </DialogActions>
  );
}
